import { createAppRequest } from '@/services/request';

const request = createAppRequest();
const BASE = '/bff/customer-intelligence/tasks';

export enum TaskStatus {
  TODO = 'todo',
  IN_PROGRESS = 'in_progress',
  DONE = 'done',
  CANCELLED = 'cancelled',
  BLOCKED = 'blocked',
}

export type TaskItem = {
  uuid: string;
  title: string;
  content?: string | null;
  description?: string | null;
  assigneeMemberUuid?: string | null;
  assigneeName?: string | null;
  priority?: string;
  status: TaskStatus;
  dueDate?: string | null;
  completedAt?: string | null;
  createdAt?: string;
  updatedAt?: string;
  [key: string]: unknown;
};

export async function queryMyTasks(params?: {
  limit?: number;
}): Promise<{ tasks: TaskItem[] }> {
  return request<{ tasks: TaskItem[] }>(`${BASE}/my`, {
    method: 'GET',
    params,
  });
}

export async function createTask(data: {
  title: string;
  content?: string;
  assigneeMemberUuid?: string | null;
  status?: TaskStatus | string;
  dueDate?: string;
  [key: string]: unknown;
}): Promise<TaskItem> {
  return request<TaskItem>(`${BASE}`, {
    method: 'POST',
    data,
  });
}

export async function completeTask(taskUuid: string): Promise<TaskItem> {
  return request<TaskItem>(`${BASE}/${taskUuid}/complete`, {
    method: 'POST',
  });
}
